<header class="header-custom">
  <div class="burger" #burger (click)="showSidenav = true">
    <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1" y1="1" x2="29" y2="1" stroke="#FF840A" stroke-width="2" stroke-linecap="round"/>
      <line x1="1" y1="9" x2="29" y2="9" stroke="#FF840A" stroke-width="2" stroke-linecap="round"/>
      <line x1="1" y1="17" x2="29" y2="17" stroke="#FF840A" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </div>
  <div class="branding">
    <a
      routerLink="/"
      class="nav-link"
      (click)="onHomeClick($event)"
    >
      <img
        src="/assets/images/logos/logo.svg"
        srcset="/assets/images/logos/logo.svg"
        alt="logo"
      >
    </a>
  </div>
  <div class="header-nav">
    <!-- КАРТА -->
    <a
      routerLink="/"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{exact: true}"
      class="nav-link nav-text header-custom__item"
      [class.active]="pageName === pageNames.MAP"
      (click)="onHomeClick($event)"
    >
      <svg class="header-custom__item__icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path class="header-custom__item__icon__stroke"
              d="M7 3.5L11.1818 12.6465M15.5 22L11.1818 12.6465M2.5 16.5L11.1818 12.6465"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="header-custom__item__icon__stroke"
              d="M20 14.6923L20 20C20 21.1046 19.1046 22 18 22L4 22C2.89543 22 2 21.1046 2 20L2 5C2 3.89543 2.89543 3 4 3L12.395 3"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="header-custom__item__icon__stroke"
              d="M21.25 7.54545C21.25 7.89798 21.1111 8.37575 20.8196 8.95784C20.5343 9.52743 20.1348 10.1347 19.6895 10.7289C18.9007 11.7813 18.0067 12.7416 17.4546 13.3064C16.9025 12.7416 16.0085 11.7813 15.2197 10.7289C14.7743 10.1347 14.3748 9.52743 14.0896 8.95784C13.7981 8.37575 13.6591 7.89798 13.6591 7.54545C13.6591 5.44928 15.3584 3.75 17.4546 3.75C19.5507 3.75 21.25 5.44928 21.25 7.54545Z"
              stroke-width="1.5" stroke-linejoin="round"/>
        <circle class="header-custom__item__icon__fill" cx="17.5" cy="7.5" r="1.5"/>
      </svg>

      <span>Карта</span>
    </a>


    <!-- ПЛАНУВАННЯ -->
    <a
      routerLink="/planning"
      routerLinkActive="active"
      class="nav-link nav-text header-custom__item"
    >
      <svg class="header-custom__item__icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path class="header-custom__item__icon__stroke"
              d="M4.00004 10.1136V8.75951V5.90909C4.00004 4.80452 4.89547 3.90909 6.00004 3.90909H18.2294C19.334 3.90909 20.2294 4.80452 20.2294 5.90909V17.5V16"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="header-custom__item__icon__stroke"
              d="M7.88849 5C7.88849 3.75736 8.89585 2.75 10.1385 2.75H14.1385C15.3811 2.75 16.3885 3.75736 16.3885 5V6C16.3885 6.13807 16.2766 6.25 16.1385 6.25H8.13849C8.00042 6.25 7.88849 6.13807 7.88849 6V5Z"
              stroke-width="1.5"/>
        <path class="header-custom__item__icon__stroke"
              d="M20.2294 15.8421L20.2294 17.186L20.2294 20C20.2294 21.1046 19.3339 22 18.2294 22L14.6385 22L6 22C4.89543 22 4 21.1046 4 20L4 5.99999C4 4.89542 4.89543 3.99999 6 3.99999L7.63846 3.99999"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <mask class="header-custom__item__icon__fill" id="path-4-inside-1_10516_18838">
          <rect fill="#FFFFFF" x="6.13849" y="9" width="5" height="5" rx="1"/>
        </mask>
        <rect class="header-custom__item__icon__stroke" x="6.13849" y="9" width="5" height="5" rx="1" stroke-width="3"
              mask="url(#path-4-inside-1_10516_18838)"/>
        <mask class="header-custom__item__icon__fill" id="path-5-inside-2_10516_18838">
          <rect fill="#FFFFFF" x="6.13849" y="15" width="5" height="5" rx="1"/>
        </mask>
        <rect class="header-custom__item__icon__stroke" x="6.13849" y="15" width="5" height="5" rx="1" stroke-width="3"
              mask="url(#path-5-inside-2_10516_18838)"/>
        <line class="header-custom__item__icon__stroke" x1="13.75" y1="18.25" x2="17.25" y2="18.25" stroke-width="1.5"
              stroke-linecap="round"/>
        <line class="header-custom__item__icon__stroke" x1="13.75" y1="12.25" x2="17.25" y2="12.25" stroke-width="1.5"
              stroke-linecap="round"/>
      </svg>

      <span>Планування</span>
    </a>


    <!-- ОГЛЯДИ -->
    <a
      routerLink="/reviews"
      routerLinkActive="active"
      class="nav-link nav-text header-custom__item"
    >
      <svg class="header-custom__item__icon" width="21" height="21" viewBox="0 0 21 21"
           xmlns="http://www.w3.org/2000/svg">
        <circle class="header-custom__item__icon__stroke" cx="15.4762" cy="15.4762" r="2.86905" stroke-width="1.5"/>
        <path class="header-custom__item__icon__stroke"
              d="M17.7381 17.7381L18.1905 18.1905L19.5476 19.5476" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round"/>
        <line class="header-custom__item__icon__stroke" x1="4.46428" y1="5.25" x2="14.7262" y2="5.25"
              stroke-width="1.5" stroke-linecap="round"/>
        <line class="header-custom__item__icon__stroke" x1="4.46428" y1="9.29761" x2="14.7262" y2="9.29761"
              stroke-width="1.5"
              stroke-linecap="round"/>
        <line class="header-custom__item__icon__stroke" x1="4.46428" y1="13.8214" x2="7.48809" y2="13.8214"
              stroke-width="1.5"
              stroke-linecap="round"/>
        <path class="header-custom__item__icon__stroke"
              d="M18 10V6.0814V3C18 1.89543 17.1046 1 16 1H3C1.89543 1 1 1.89543 1 3V18C1 19.1046 1.89543 20 3 20H11.5238"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Огляди</span>
    </a>


    <!-- РЕЙТИНГ ПОЛІВ -->
    <a
      routerLink="/fields-rating"
      routerLinkActive="active"
      class="nav-link nav-text header-custom__item"
    >
      <svg class="header-custom__item__icon" width="20" height="21"
           viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask class="header-custom__item__icon__fill" id="path-1-inside-1_10567_9686">
          <path fill="#FFFFFF" fill-rule="evenodd" clip-rule="evenodd"
                d="M20 3C20 1.34315 18.6569 0 17 0H3C1.34315 0 0 1.34315 0 3V15C0 16.6569 1.34314 18 3 18H7.6906L9.84152 20.7941C9.92158 20.8981 10.0784 20.8981 10.1585 20.7941L12.3094 18H17C18.6569 18 20 16.6569 20 15V3Z"/>
        </mask>
        <path class="header-custom__item__icon__fill"
              d="M7.6906 18L8.87921 17.085C8.59525 16.7161 8.15611 16.5 7.6906 16.5V18ZM9.84152 20.7941L11.0301 19.8791L11.0301 19.8791L9.84152 20.7941ZM10.1585 20.7941L8.96987 19.8791L8.96987 19.8791L10.1585 20.7941ZM12.3094 18V16.5C11.8439 16.5 11.4048 16.7161 11.1208 17.085L12.3094 18ZM17 1.5C17.8284 1.5 18.5 2.17157 18.5 3H21.5C21.5 0.514719 19.4853 -1.5 17 -1.5V1.5ZM3 1.5H17V-1.5H3V1.5ZM1.5 3C1.5 2.17157 2.17157 1.5 3 1.5V-1.5C0.514719 -1.5 -1.5 0.514718 -1.5 3H1.5ZM1.5 15V3H-1.5V15H1.5ZM3 16.5C2.17157 16.5 1.5 15.8284 1.5 15H-1.5C-1.5 17.4853 0.514716 19.5 3 19.5V16.5ZM7.6906 16.5H3V19.5H7.6906V16.5ZM11.0301 19.8791L8.87921 17.085L6.50199 18.915L8.65291 21.7091L11.0301 19.8791ZM8.96987 19.8791C9.49026 19.2031 10.5097 19.2031 11.0301 19.8791L8.65291 21.7091C9.33342 22.5931 10.6666 22.5931 11.3471 21.7091L8.96987 19.8791ZM11.1208 17.085L8.96987 19.8791L11.3471 21.7091L13.498 18.915L11.1208 17.085ZM17 16.5H12.3094V19.5H17V16.5ZM18.5 15C18.5 15.8284 17.8284 16.5 17 16.5V19.5C19.4853 19.5 21.5 17.4853 21.5 15H18.5ZM18.5 3V15H21.5V3H18.5Z"
              mask="url(#path-1-inside-1_10567_9686)"/>
        <path class="header-custom__item__icon__stroke"
              d="M9.91033 4.1817C9.94701 4.10737 10.053 4.10737 10.0897 4.1817L11.4462 6.93031C11.4608 6.95983 11.4889 6.98028 11.5215 6.98502L14.5548 7.42578C14.6368 7.4377 14.6695 7.53849 14.6102 7.59635L12.4153 9.73585C12.3917 9.75882 12.381 9.79192 12.3865 9.82436L12.9047 12.8454C12.9187 12.9271 12.8329 12.9894 12.7596 12.9508L10.0465 11.5245C10.0174 11.5091 9.9826 11.5091 9.95347 11.5245L7.24042 12.9508C7.16706 12.9894 7.08132 12.9271 7.09533 12.8454L7.61347 9.82436C7.61904 9.79192 7.60828 9.75882 7.58471 9.73585L5.38981 7.59635C5.33046 7.53849 5.36321 7.4377 5.44523 7.42578L8.47851 6.98502C8.51108 6.98028 8.53924 6.95983 8.5538 6.93031L9.91033 4.1817Z"
              stroke-width="1.5"/>
      </svg>

      <span>Рейтинг полів</span>
    </a>


    <!-- ЛАБОРАТОРІЯ ГРУНТІВ -->
    <a
      routerLink="/soils-laboratory"
      routerLinkActive="active"
      class="nav-link nav-text header-custom__item"
    >
      <svg class="header-custom__item__icon" width="19" height="20" viewBox="0 0 19 20" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.0273 1V7.49824C12.0273 8.0768 12.1946 8.64301 12.509 9.12866L16.9014 15.9131C17.763 17.2438 16.8078 19 15.2226 19H3.67743C2.09219 19 1.13705 17.2438 1.99858 15.9131L6.39101 9.12866C6.70544 8.64301 6.87273 8.0768 6.87273 7.49825V1"
          class="header-custom__item__icon__stroke" stroke-width="1.5"/>
        <line x1="6.15002" y1="1.15039" x2="12.75" y2="1.15039" class="header-custom__item__icon__stroke"
              stroke-width="1.5"
              stroke-linecap="round"/>
        <line x1="7.05005" y1="6.5498" x2="11.85" y2="6.5498" class="header-custom__item__icon__stroke"
              stroke-width="1.5"
              stroke-linecap="round"/>
        <circle class="header-custom__item__icon__fill" cx="11.15" cy="14.85" r="1.35"/>
        <circle class="header-custom__item__icon__fill" cx="8.09995" cy="11.8004" r="0.9"/>
      </svg>


      <span>Лабораторія грунтів</span>
    </a>


    <!-- ЗВІТИ -->
    <a
      routerLink="/reports"
      routerLinkActive="active"
      class="nav-link nav-text header-custom__item"
    >
      <svg class="header-custom__item__icon" width="18" height="21" viewBox="0 0 18 21" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path class="header-custom__item__icon__stroke"
              d="M1.00001 8.11363V6.75951V3.90909C1.00001 2.80452 1.89544 1.90909 3.00001 1.90909H15.2294C16.3339 1.90909 17.2294 2.80452 17.2294 3.90909V15.5V14"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="header-custom__item__icon__stroke"
              d="M4.88846 3C4.88846 1.75736 5.89582 0.75 7.13846 0.75H11.1385C12.3811 0.75 13.3885 1.75736 13.3885 3V4C13.3885 4.13807 13.2765 4.25 13.1385 4.25H5.13846C5.00039 4.25 4.88846 4.13807 4.88846 4V3Z"
              fill="black" stroke-width="1.5"/>
        <path class="header-custom__item__icon__stroke"
              d="M17.2294 13.8421L17.2294 15.186L17.2294 18C17.2294 19.1046 16.3339 20 15.2294 20L11.6385 20L3 20C1.89543 20 1 19.1046 1 18L1 3.99999C1 2.89542 1.89543 1.99999 3 1.99999L4.63846 1.99999"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="header-custom__item__icon__fill"
              d="M7.50172 8.94253C7.19384 8.66544 6.71962 8.69039 6.44253 8.99828C6.16544 9.30616 6.19039 9.78038 6.49828 10.0575L7.50172 8.94253ZM8.66667 11L8.16494 11.5575C8.45017 11.8142 8.88316 11.8142 9.16839 11.5575L8.66667 11ZM12.5017 8.55747C12.8096 8.28038 12.8346 7.80616 12.5575 7.49828C12.2804 7.19039 11.8062 7.16544 11.4983 7.44253L12.5017 8.55747ZM6.49828 10.0575L7.33161 10.8075L8.33506 9.69253L7.50172 8.94253L6.49828 10.0575ZM7.33161 10.8075L8.16494 11.5575L9.16839 10.4425L8.33506 9.69253L7.33161 10.8075ZM9.16839 11.5575L12.5017 8.55747L11.4983 7.44253L8.16494 10.4425L9.16839 11.5575Z"
        />
        <path class="header-custom__item__icon__fill"
              d="M5 14.25C4.58579 14.25 4.25 14.5858 4.25 15C4.25 15.4142 4.58579 15.75 5 15.75L5 14.25ZM13 15.75C13.4142 15.75 13.75 15.4142 13.75 15C13.75 14.5858 13.4142 14.25 13 14.25L13 15.75ZM5 15.75L13 15.75L13 14.25L5 14.25L5 15.75Z"
        />
      </svg>

      <span>Звіти</span>
    </a>


    <!-- ЗВІТИ BI -->
    <!-- <a
      href="https://qlik.agrichain.com.ua/"
      target="_blank"
      class="nav-link nav-text header-custom__item"
    >
      <svg class="header-custom__item__icon" width="20" height="21" viewBox="0 0 20 21" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path class="header-custom__item__icon__stroke"
              d="M2.86155 8.11363V6.75951V3.90909C2.86155 2.80452 3.75699 1.90909 4.86155 1.90909H17.0909C18.1955 1.90909 19.0909 2.80452 19.0909 3.90909V18.0455C19.0909 19.15 18.1955 20.0455 17.0909 20.0455H11.9318"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="header-custom__item__icon__stroke"
              d="M6.75 3C6.75 1.75736 7.75736 0.75 9 0.75H13C14.2426 0.75 15.25 1.75736 15.25 3V4C15.25 4.13807 15.1381 4.25 15 4.25H7C6.86193 4.25 6.75 4.13807 6.75 4V3Z"
              fill="black" stroke-width="1.5"/>
        <mask class="header-custom__item__icon__fill" id="path-3-inside-1_10567_9672">
          <path fill="#FFFFFF"
                d="M11.4545 15.2727C11.4545 16.4055 11.1186 17.5128 10.4893 18.4546C9.86 19.3965 8.96553 20.1305 7.919 20.564C6.87248 20.9975 5.72092 21.1109 4.60994 20.8899C3.49896 20.669 2.47845 20.1235 1.67748 19.3225C0.876506 18.5215 0.331036 17.501 0.110048 16.39C-0.11094 15.2791 0.00247897 14.1275 0.435963 13.081C0.869446 12.0345 1.60353 11.14 2.54537 10.5107C3.48722 9.88134 4.59452 9.54544 5.72727 9.54544V15.2727H11.4545Z"/>
        </mask>
        <path class="header-custom__item__icon__stroke"
              d="M11.4545 15.2727C11.4545 16.4055 11.1186 17.5128 10.4893 18.4546C9.86 19.3965 8.96553 20.1305 7.919 20.564C6.87248 20.9975 5.72092 21.1109 4.60994 20.8899C3.49896 20.669 2.47845 20.1235 1.67748 19.3225C0.876506 18.5215 0.331036 17.501 0.110048 16.39C-0.11094 15.2791 0.00247897 14.1275 0.435963 13.081C0.869446 12.0345 1.60353 11.14 2.54537 10.5107C3.48722 9.88134 4.59452 9.54544 5.72727 9.54544V15.2727H11.4545Z"
              fill="none" stroke-width="3" mask="url(#path-3-inside-1_10567_9672)"/>
        <path class="header-custom__item__icon__stroke"
              d="M7.74998 7.7951C8.31311 7.86316 8.86554 8.00772 9.39175 8.22569C10.15 8.53978 10.839 9.00015 11.4194 9.58052C11.9998 10.1609 12.4601 10.8499 12.7742 11.6082C12.9922 12.1344 13.1367 12.6868 13.2048 13.2499L7.74998 13.2499L7.74998 7.7951Z"
              fill="none" stroke-width="1.5"/>
      </svg>


      <span>Звіти BI</span>
    </a> -->


    <!-- ЗВІТИ POWER BI -->
    <div
      class="nav-link nav-text header-custom__item"
      href="#"
      (click)="openPowerBiModal.emit()">
      <svg class="header-custom__item__icon" width="21" height="21" viewBox="0 0 21 21" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path class="header-custom__item__icon__stroke"
              d="M3.86155 8.11363V6.75951V3.90909C3.86155 2.80452 4.75699 1.90909 5.86155 1.90909H18.0909C19.1955 1.90909 20.0909 2.80452 20.0909 3.90909V18.0455C20.0909 19.15 19.1955 20.0455 18.0909 20.0455H12.9318"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path class="header-custom__item__icon__stroke"
              d="M7.75 3C7.75 1.75736 8.75736 0.75 10 0.75H14C15.2426 0.75 16.25 1.75736 16.25 3V4C16.25 4.13807 16.1381 4.25 16 4.25H8C7.86193 4.25 7.75 4.13807 7.75 4V3Z"
              fill="black" stroke-width="1.5"/>
        <path class="header-custom__item__icon__fill"
              d="M1.06816 14.5142C0.799855 14.7527 0.775687 15.1635 1.01418 15.4318C1.25268 15.7001 1.66353 15.7243 1.93184 15.4858L1.06816 14.5142ZM6 11L6.45962 10.5404C6.21626 10.297 5.82539 10.2855 5.56816 10.5142L6 11ZM10 15L9.54038 15.4596C9.77458 15.6938 10.1474 15.7145 10.4061 15.5076L10 15ZM15.4061 11.5076C15.6864 11.2833 15.7318 10.8743 15.5076 10.5939C15.2833 10.3136 14.8743 10.2682 14.5939 10.4924L15.4061 11.5076ZM1.93184 15.4858L6.43184 11.4858L5.56816 10.5142L1.06816 14.5142L1.93184 15.4858ZM5.54038 11.4596L9.54038 15.4596L10.4596 14.5404L6.45962 10.5404L5.54038 11.4596ZM10.4061 15.5076L15.4061 11.5076L14.5939 10.4924L9.59395 14.4924L10.4061 15.5076Z"
        />
        <path class="header-custom__item__icon__fill"
              d="M12 9.35C11.641 9.35 11.35 9.64101 11.35 10C11.35 10.359 11.641 10.65 12 10.65V9.35ZM16 10H16.65C16.65 9.64101 16.359 9.35 16 9.35V10ZM15.35 14C15.35 14.359 15.641 14.65 16 14.65C16.359 14.65 16.65 14.359 16.65 14H15.35ZM12 10.65H16V9.35H12V10.65ZM15.35 10V14H16.65V10H15.35Z"
        />
        <path class="header-custom__item__icon__fill"
              d="M3 17.35C2.64101 17.35 2.35 17.641 2.35 18C2.35 18.359 2.64101 18.65 3 18.65L3 17.35ZM9 18.65C9.35898 18.65 9.65 18.359 9.65 18C9.65 17.641 9.35899 17.35 9 17.35L9 18.65ZM3 18.65L9 18.65L9 17.35L3 17.35L3 18.65Z"
        />
      </svg>


      <span>Звіти Power BI</span>
    </div>
  </div>
  <div class="header-actions">
    <app-actions-dropdown
      [pageName]="pageName"
      [soilAnalysisUploading]="soilAnalysisUploading$ | async"
      (filesAdded)="onFilesAdded($event)"></app-actions-dropdown>
    <span class="vertical-divider"></span>
    <app-notifications-dropdown (navigateToStateWithParams)="openNotification($event)"></app-notifications-dropdown>
    <span class="vertical-divider"></span>
    <clr-dropdown>
      <button class="nav-icon dropdown-trigger" clrDropdownTrigger>
        <div class="user-avatar">
          <span class="user-avatar__initials">{{getUserInitials()}}</span>
        </div>
      </button>
      <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right" class="header-custom__dropdown-menu">
        <div class="header-custom__dropdown-menu__user-info">
          <div class="user-avatar user-avatar--large">
            <span class="user-avatar__initials">{{getUserInitials()}}</span>
          </div>
          <div class="header-custom__dropdown-menu__user-info__text">
            <div class="header-custom__dropdown-menu__user-info__name">{{user.firstName + ' ' + user.lastName}}</div>
            <div class="header-custom__dropdown-menu__user-info__email">{{user.email}}</div>
          </div>
        </div>
        <div class="header-custom__dropdown-menu__divider"></div>
        <div class="header-custom__dropdown-menu__links">
          <a [href]="authUrl+'/personal-information'" class="header-custom__dropdown-menu__links__item" target="_blank"
             clrDropdownItem>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 20C20 16.134 16.4183 13 12 13C7.58172 13 4 16.134 4 20" stroke="#120900" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M12 3.75C13.7949 3.75 15.25 5.20507 15.25 7C15.25 8.79493 13.7949 10.25 12 10.25C10.2051 10.25 8.75 8.79493 8.75 7C8.75 5.20507 10.2051 3.75 12 3.75Z" stroke="#120900" stroke-width="1.5"/>
            </svg>
            <span>Профіль</span>
          </a>
          <a [href]="authUrl+'/admin/users'"
             class="header-custom__dropdown-menu__links__item cabinet-link" target="_blank"
             clrDropdownItem *appHasRole="userRoles.ROLE_ADMIN">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.49988 0.75H16.4999C16.9141 0.75 17.2499 1.08579 17.2499 1.5V11.5C17.2499 11.9142 16.9141 12.25 16.4999 12.25H1.49988C1.08566 12.25 0.749878 11.9142 0.749878 11.5V1.5C0.749878 1.08579 1.08566 0.75 1.49988 0.75Z" stroke="#120900" stroke-width="1.5"/>
              <path d="M9 13.0357V17" stroke="#120900" stroke-width="1.5"/>
              <path d="M5.03577 16.3393H12.9643" stroke="#120900" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span>Кабінет</span>
          </a>
          <a href="https://files.agrichain.com.ua/s/HJtJeaErcp9arhl"
             class="header-custom__dropdown-menu__links__item upload-link" target="_blank" clrDropdownItem>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7147 9.4849C18.0973 9.88327 18.0973 10.5292 17.7147 10.9275L13.0234 15.8133C12.6409 16.2117 12.0207 16.2117 11.6382 15.8133L6.94689 10.9275C6.56437 10.5292 6.56437 9.88327 6.94689 9.4849C7.3294 9.08653 7.94958 9.08653 8.3321 9.4849L12.3308 13.6494L16.3295 9.4849C16.712 9.08653 17.3322 9.08653 17.7147 9.4849Z" fill="#120900"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3308 3L13.3308 13.4735C13.3308 14.0258 12.8831 14.4735 12.3308 14.4735C11.7785 14.4735 11.3308 14.0258 11.3308 13.4735L11.3308 3C11.3308 2.44772 11.7785 2 12.3308 2C12.8831 2 13.3308 2.44772 13.3308 3Z" fill="#120900"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.04761 12.9872C3.59989 12.9872 4.04761 13.4349 4.04761 13.9872V17.0911C4.04761 18.1957 4.94304 19.0911 6.04761 19.0911H17.9524C19.057 19.0911 19.9524 18.1957 19.9524 17.0911V13.9872C19.9524 13.4349 20.4001 12.9872 20.9524 12.9872C21.5047 12.9872 21.9524 13.4349 21.9524 13.9872V17.0911C21.9524 19.3002 20.1615 21.0911 17.9524 21.0911H6.04761C3.83847 21.0911 2.04761 19.3002 2.04761 17.0911V13.9872C2.04761 13.4349 2.49532 12.9872 3.04761 12.9872Z" fill="#120900"/>
            </svg>
            <span>Завантажити керівництво користувача</span>
          </a>
          <a (click)="logout()" class="header-custom__dropdown-menu__links__item logout-link" clrDropdownItem>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#120900" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 17L21 12L16 7" stroke="#120900" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 12H9" stroke="#120900" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Вийти</span>
          </a>
        </div>
      </clr-dropdown-menu>
    </clr-dropdown>
  </div>
  <section class="sidenav-wrap"
           #sidenav
           [class.active]="showSidenav">
    <ul class="sidenav" (click)="showSidenav = false">
      <li>
        <a
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}"
          class="nav-link nav-text"
          [class.active]="pageName === pageNames.MAP"
          (click)="onHomeClick($event)"
        >
          <!-- Карта -->
          <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path class="icon__stroke"
                  d="M7 3.5L11.1818 12.6465M15.5 22L11.1818 12.6465M2.5 16.5L11.1818 12.6465"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="icon__stroke"
                  d="M20 14.6923L20 20C20 21.1046 19.1046 22 18 22L4 22C2.89543 22 2 21.1046 2 20L2 5C2 3.89543 2.89543 3 4 3L12.395 3"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="icon__stroke"
                  d="M21.25 7.54545C21.25 7.89798 21.1111 8.37575 20.8196 8.95784C20.5343 9.52743 20.1348 10.1347 19.6895 10.7289C18.9007 11.7813 18.0067 12.7416 17.4546 13.3064C16.9025 12.7416 16.0085 11.7813 15.2197 10.7289C14.7743 10.1347 14.3748 9.52743 14.0896 8.95784C13.7981 8.37575 13.6591 7.89798 13.6591 7.54545C13.6591 5.44928 15.3584 3.75 17.4546 3.75C19.5507 3.75 21.25 5.44928 21.25 7.54545Z"
                  stroke-width="1.5" stroke-linejoin="round"/>
            <circle class="icon__fill" cx="17.5" cy="7.5" r="1.5"/>
          </svg>
          <span>Карта</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/planning"
          routerLinkActive="active"
          class="nav-link nav-text"
        >
          <!-- ПЛАНУВАННЯ -->
          <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              class="icon__stroke"
              d="M1.00001 8.11373V6.7596V3.90918C1.00001 2.80461 1.89544 1.90918 3.00001 1.90918H15.2294C16.3339 1.90918 17.2294 2.80461 17.2294 3.90918V15.5001V14.0001"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path
              class="icon__stroke"
              d="M4.88846 3C4.88846 1.75736 5.89582 0.75 7.13846 0.75H11.1385C12.3811 0.75 13.3885 1.75736 13.3885 3V4C13.3885 4.13807 13.2765 4.25 13.1385 4.25H5.13846C5.00039 4.25 4.88846 4.13807 4.88846 4V3Z"
              fill="black" stroke-width="1.5"/>
            <path
              class="icon__stroke"
              d="M17.2294 13.8421L17.2294 15.186L17.2294 18C17.2294 19.1046 16.3339 20 15.2294 20L11.6385 20L3 20C1.89543 20 1 19.1046 1 18L1 3.99999C1 2.89542 1.89543 1.99999 3 1.99999L4.63846 1.99999"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <mask class="icon__fill" id="path-4-inside-1_11504_1651" fill="white">
              <rect x="3.13847" y="7" width="5" height="5" rx="1"/>
            </mask>
            <rect class="icon__stroke" x="3.13847" y="7" width="5" height="5" rx="1" stroke-width="3"
                  mask="url(#path-4-inside-1_11504_1651)"/>
            <mask class="icon__fill" id="path-5-inside-2_11504_1651" fill="white">
              <rect x="3.13847" y="13" width="5" height="5" rx="1"/>
            </mask>
            <rect class="icon__stroke" x="3.13847" y="13" width="5" height="5" rx="1" stroke-width="3"
                  mask="url(#path-5-inside-2_11504_1651)"/>
            <line class="icon__stroke" x1="10.75" y1="16.25" x2="14.25" y2="16.25" stroke-width="1.5"
                  stroke-linecap="round"/>
            <line class="icon__stroke" x1="10.75" y1="10.25" x2="14.25" y2="10.25" stroke-width="1.5"
                  stroke-linecap="round"/>
          </svg>
          <span>Планування</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/reviews"
          routerLinkActive="active"
          class="nav-link nav-text"
        >
          <!-- ОГЛЯДИ -->
          <svg class="icon" width="21" height="21" viewBox="0 0 21 21"
               xmlns="http://www.w3.org/2000/svg">
            <circle class="icon__stroke" cx="15.4762" cy="15.4762" r="2.86905" stroke-width="1.5"/>
            <path class="icon__stroke"
                  d="M17.7381 17.7381L18.1905 18.1905L19.5476 19.5476" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <line class="icon__stroke" x1="4.46428" y1="5.25" x2="14.7262" y2="5.25"
                  stroke-width="1.5" stroke-linecap="round"/>
            <line class="icon__stroke" x1="4.46428" y1="9.29761" x2="14.7262" y2="9.29761"
                  stroke-width="1.5"
                  stroke-linecap="round"/>
            <line class="icon__stroke" x1="4.46428" y1="13.8214" x2="7.48809" y2="13.8214"
                  stroke-width="1.5"
                  stroke-linecap="round"/>
            <path class="icon__stroke"
                  d="M18 10V6.0814V3C18 1.89543 17.1046 1 16 1H3C1.89543 1 1 1.89543 1 3V18C1 19.1046 1.89543 20 3 20H11.5238"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Огляди</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/fields-rating"
          routerLinkActive="active"
          class="nav-link nav-text"
        >
          <!-- РЕЙТИНГ ПОЛІВ -->
          <svg class="icon" width="20" height="21"
               viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask class="icon__fill" id="path-1-inside-1_10567_9686">
              <path fill="#FFFFFF" fill-rule="evenodd" clip-rule="evenodd"
                    d="M20 3C20 1.34315 18.6569 0 17 0H3C1.34315 0 0 1.34315 0 3V15C0 16.6569 1.34314 18 3 18H7.6906L9.84152 20.7941C9.92158 20.8981 10.0784 20.8981 10.1585 20.7941L12.3094 18H17C18.6569 18 20 16.6569 20 15V3Z"/>
            </mask>
            <path class="icon__fill"
                  d="M7.6906 18L8.87921 17.085C8.59525 16.7161 8.15611 16.5 7.6906 16.5V18ZM9.84152 20.7941L11.0301 19.8791L11.0301 19.8791L9.84152 20.7941ZM10.1585 20.7941L8.96987 19.8791L8.96987 19.8791L10.1585 20.7941ZM12.3094 18V16.5C11.8439 16.5 11.4048 16.7161 11.1208 17.085L12.3094 18ZM17 1.5C17.8284 1.5 18.5 2.17157 18.5 3H21.5C21.5 0.514719 19.4853 -1.5 17 -1.5V1.5ZM3 1.5H17V-1.5H3V1.5ZM1.5 3C1.5 2.17157 2.17157 1.5 3 1.5V-1.5C0.514719 -1.5 -1.5 0.514718 -1.5 3H1.5ZM1.5 15V3H-1.5V15H1.5ZM3 16.5C2.17157 16.5 1.5 15.8284 1.5 15H-1.5C-1.5 17.4853 0.514716 19.5 3 19.5V16.5ZM7.6906 16.5H3V19.5H7.6906V16.5ZM11.0301 19.8791L8.87921 17.085L6.50199 18.915L8.65291 21.7091L11.0301 19.8791ZM8.96987 19.8791C9.49026 19.2031 10.5097 19.2031 11.0301 19.8791L8.65291 21.7091C9.33342 22.5931 10.6666 22.5931 11.3471 21.7091L8.96987 19.8791ZM11.1208 17.085L8.96987 19.8791L11.3471 21.7091L13.498 18.915L11.1208 17.085ZM17 16.5H12.3094V19.5H17V16.5ZM18.5 15C18.5 15.8284 17.8284 16.5 17 16.5V19.5C19.4853 19.5 21.5 17.4853 21.5 15H18.5ZM18.5 3V15H21.5V3H18.5Z"
                  mask="url(#path-1-inside-1_10567_9686)"/>
            <path class="icon__stroke"
                  d="M9.91033 4.1817C9.94701 4.10737 10.053 4.10737 10.0897 4.1817L11.4462 6.93031C11.4608 6.95983 11.4889 6.98028 11.5215 6.98502L14.5548 7.42578C14.6368 7.4377 14.6695 7.53849 14.6102 7.59635L12.4153 9.73585C12.3917 9.75882 12.381 9.79192 12.3865 9.82436L12.9047 12.8454C12.9187 12.9271 12.8329 12.9894 12.7596 12.9508L10.0465 11.5245C10.0174 11.5091 9.9826 11.5091 9.95347 11.5245L7.24042 12.9508C7.16706 12.9894 7.08132 12.9271 7.09533 12.8454L7.61347 9.82436C7.61904 9.79192 7.60828 9.75882 7.58471 9.73585L5.38981 7.59635C5.33046 7.53849 5.36321 7.4377 5.44523 7.42578L8.47851 6.98502C8.51108 6.98028 8.53924 6.95983 8.5538 6.93031L9.91033 4.1817Z"
                  stroke-width="1.5"/>
          </svg>
          <span>Рейтинг полів</span>
        </a>
      </li>
      <li>
        <!-- ЛАБОРАТОРІЯ ГРУНТІВ -->
        <a
          routerLink="/soils-laboratory"
          routerLinkActive="active"
          class="nav-link nav-text"
        >
          <svg class="icon" width="19" height="20" viewBox="0 0 19 20" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.0273 1V7.49824C12.0273 8.0768 12.1946 8.64301 12.509 9.12866L16.9014 15.9131C17.763 17.2438 16.8078 19 15.2226 19H3.67743C2.09219 19 1.13705 17.2438 1.99858 15.9131L6.39101 9.12866C6.70544 8.64301 6.87273 8.0768 6.87273 7.49825V1"
              class="icon__stroke" stroke-width="1.5"/>
            <line x1="6.15002" y1="1.15039" x2="12.75" y2="1.15039" class="icon__stroke"
                  stroke-width="1.5"
                  stroke-linecap="round"/>
            <line x1="7.05005" y1="6.5498" x2="11.85" y2="6.5498" class="icon__stroke"
                  stroke-width="1.5"
                  stroke-linecap="round"/>
            <circle class="icon__fill" cx="11.15" cy="14.85" r="1.35"/>
            <circle class="icon__fill" cx="8.09995" cy="11.8004" r="0.9"/>
          </svg>
          <span>Лабораторія грунтів</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/reports"
          routerLinkActive="active"
          class="nav-link nav-text"
        >
          <!-- ЗВІТИ -->
          <svg class="icon" width="18" height="21" viewBox="0 0 18 21" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path class="icon__stroke"
                  d="M1.00001 8.11363V6.75951V3.90909C1.00001 2.80452 1.89544 1.90909 3.00001 1.90909H15.2294C16.3339 1.90909 17.2294 2.80452 17.2294 3.90909V15.5V14"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="icon__stroke"
                  d="M4.88846 3C4.88846 1.75736 5.89582 0.75 7.13846 0.75H11.1385C12.3811 0.75 13.3885 1.75736 13.3885 3V4C13.3885 4.13807 13.2765 4.25 13.1385 4.25H5.13846C5.00039 4.25 4.88846 4.13807 4.88846 4V3Z"
                  fill="black" stroke-width="1.5"/>
            <path class="icon__stroke"
                  d="M17.2294 13.8421L17.2294 15.186L17.2294 18C17.2294 19.1046 16.3339 20 15.2294 20L11.6385 20L3 20C1.89543 20 1 19.1046 1 18L1 3.99999C1 2.89542 1.89543 1.99999 3 1.99999L4.63846 1.99999"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="icon__fill"
                  d="M7.50172 8.94253C7.19384 8.66544 6.71962 8.69039 6.44253 8.99828C6.16544 9.30616 6.19039 9.78038 6.49828 10.0575L7.50172 8.94253ZM8.66667 11L8.16494 11.5575C8.45017 11.8142 8.88316 11.8142 9.16839 11.5575L8.66667 11ZM12.5017 8.55747C12.8096 8.28038 12.8346 7.80616 12.5575 7.49828C12.2804 7.19039 11.8062 7.16544 11.4983 7.44253L12.5017 8.55747ZM6.49828 10.0575L7.33161 10.8075L8.33506 9.69253L7.50172 8.94253L6.49828 10.0575ZM7.33161 10.8075L8.16494 11.5575L9.16839 10.4425L8.33506 9.69253L7.33161 10.8075ZM9.16839 11.5575L12.5017 8.55747L11.4983 7.44253L8.16494 10.4425L9.16839 11.5575Z"
            />
            <path class="icon__fill"
                  d="M5 14.25C4.58579 14.25 4.25 14.5858 4.25 15C4.25 15.4142 4.58579 15.75 5 15.75L5 14.25ZM13 15.75C13.4142 15.75 13.75 15.4142 13.75 15C13.75 14.5858 13.4142 14.25 13 14.25L13 15.75ZM5 15.75L13 15.75L13 14.25L5 14.25L5 15.75Z"
            />
          </svg>
          <span>Звіти</span>
        </a>
      </li>
      <li>
        <div
          class="nav-link nav-text"
          href="#"
          (click)="openPowerBiModal.emit()">
          <!-- ЗВІТИ POWER BI -->
          <svg class="icon" width="21" height="21" viewBox="0 0 21 21" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path class="icon__stroke"
                  d="M3.86155 8.11363V6.75951V3.90909C3.86155 2.80452 4.75699 1.90909 5.86155 1.90909H18.0909C19.1955 1.90909 20.0909 2.80452 20.0909 3.90909V18.0455C20.0909 19.15 19.1955 20.0455 18.0909 20.0455H12.9318"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path class="icon__stroke"
                  d="M7.75 3C7.75 1.75736 8.75736 0.75 10 0.75H14C15.2426 0.75 16.25 1.75736 16.25 3V4C16.25 4.13807 16.1381 4.25 16 4.25H8C7.86193 4.25 7.75 4.13807 7.75 4V3Z"
                  fill="black" stroke-width="1.5"/>
            <path class="icon__fill"
                  d="M1.06816 14.5142C0.799855 14.7527 0.775687 15.1635 1.01418 15.4318C1.25268 15.7001 1.66353 15.7243 1.93184 15.4858L1.06816 14.5142ZM6 11L6.45962 10.5404C6.21626 10.297 5.82539 10.2855 5.56816 10.5142L6 11ZM10 15L9.54038 15.4596C9.77458 15.6938 10.1474 15.7145 10.4061 15.5076L10 15ZM15.4061 11.5076C15.6864 11.2833 15.7318 10.8743 15.5076 10.5939C15.2833 10.3136 14.8743 10.2682 14.5939 10.4924L15.4061 11.5076ZM1.93184 15.4858L6.43184 11.4858L5.56816 10.5142L1.06816 14.5142L1.93184 15.4858ZM5.54038 11.4596L9.54038 15.4596L10.4596 14.5404L6.45962 10.5404L5.54038 11.4596ZM10.4061 15.5076L15.4061 11.5076L14.5939 10.4924L9.59395 14.4924L10.4061 15.5076Z"
            />
            <path class="icon__fill"
                  d="M12 9.35C11.641 9.35 11.35 9.64101 11.35 10C11.35 10.359 11.641 10.65 12 10.65V9.35ZM16 10H16.65C16.65 9.64101 16.359 9.35 16 9.35V10ZM15.35 14C15.35 14.359 15.641 14.65 16 14.65C16.359 14.65 16.65 14.359 16.65 14H15.35ZM12 10.65H16V9.35H12V10.65ZM15.35 10V14H16.65V10H15.35Z"
            />
            <path class="icon__fill"
                  d="M3 17.35C2.64101 17.35 2.35 17.641 2.35 18C2.35 18.359 2.64101 18.65 3 18.65L3 17.35ZM9 18.65C9.35898 18.65 9.65 18.359 9.65 18C9.65 17.641 9.35899 17.35 9 17.35L9 18.65ZM3 18.65L9 18.65L9 17.35L3 17.35L3 18.65Z"
            />
          </svg>
          <span>Звіти Power BI</span>
        </div>
      </li>
    </ul>
  </section>
</header>
